import getApiBase from "../utils/apiBase";

export const CUSTOM_DESIGN_API_BASE = getApiBase();

export const projectStatusTranslationKeys = {
  draft: "design.enum.projectStatus.draft",
  submitted: "design.enum.projectStatus.submitted",
  feasibility_review: "design.enum.projectStatus.feasibilityReview",
  design_payment_pending: "design.enum.projectStatus.designPaymentPending",
  modeling: "design.enum.projectStatus.modeling",
  design_review: "design.enum.projectStatus.designReview",
  prototype_payment_pending: "design.enum.projectStatus.prototypePaymentPending",
  prototyping: "design.enum.projectStatus.prototyping",
  prototype_shipped: "design.enum.projectStatus.prototypeShipped",
  sample_review: "design.enum.projectStatus.sampleReview",
  production_payment_pending: "design.enum.projectStatus.productionPaymentPending",
  in_production: "design.enum.projectStatus.inProduction",
  completed: "design.enum.projectStatus.completed",
  cancelled: "design.enum.projectStatus.cancelled",
};

// Internal admin screens remain English-only and use these legacy display helpers.
export const projectStatusLabels = {
  draft: "Draft", submitted: "Submitted", feasibility_review: "Feasibility review",
  design_payment_pending: "Design quote ready", modeling: "3D modeling", design_review: "Design review",
  prototype_payment_pending: "Prototype quote ready", prototyping: "Prototype production",
  prototype_shipped: "Prototype shipped", sample_review: "Sample review",
  production_payment_pending: "Production quote ready", in_production: "In production",
  completed: "Completed", cancelled: "Cancelled",
};

export const quoteTypeTranslationKeys = {
  design: "design.enum.quoteType.design",
  prototype: "design.enum.quoteType.prototype",
  small_batch: "design.enum.quoteType.smallBatch",
  mold_production: "design.enum.quoteType.moldProduction",
};

export const quoteTypeLabels = {
  design: "3D design", prototype: "Prototype", small_batch: "Small-batch production",
  mold_production: "Mold & production",
};

export const serviceTypeTranslationKeys = {
  prototype: "design.service.prototype.title",
  small_batch: "design.service.smallBatch.title",
  mold: "design.service.mold.title",
};

export const processTranslationKeys = {
  not_sure: "design.form.process.notSure",
  "3d_printing": "design.form.process.printing",
  cnc: "design.form.process.cnc",
  molding: "design.form.process.molding",
};

export const timelineTranslationKeys = {
  flexible: "design.form.timeline.flexible",
  "2-4_weeks": "design.form.timeline.twoFourWeeks",
  "1-2_months": "design.form.timeline.oneTwoMonths",
  "3+_months": "design.form.timeline.threePlusMonths",
};

export const quantityTranslationKeys = {
  "1": "design.form.quantityOne",
  "2-10": "design.form.quantityTwoTen",
  "11-100": "design.form.quantityElevenHundred",
  "101-1000": "design.form.quantityHundredThousand",
  "1000+": "design.form.quantityMore",
};

export const quoteStatusTranslationKeys = {
  draft: "design.enum.quoteStatus.draft",
  published: "design.enum.quoteStatus.published",
  checkout_started: "design.enum.quoteStatus.checkoutStarted",
  paid: "design.enum.quoteStatus.paid",
  expired: "design.enum.quoteStatus.expired",
  cancelled: "design.enum.quoteStatus.cancelled",
};

export const versionStatusTranslationKeys = {
  pending_review: "design.enum.versionStatus.pendingReview",
  approved: "design.enum.versionStatus.approved",
  changes_requested: "design.enum.versionStatus.changesRequested",
};

export const eventTypeTranslationKeys = {
  draft_created: "design.enum.event.draftCreated",
  project_submitted: "design.enum.event.projectSubmitted",
  customer_message: "design.enum.event.customerMessage",
  admin_message: "design.enum.event.adminMessage",
  status_changed: "design.enum.event.statusChanged",
  quote_draft_created: "design.enum.event.quoteDraftCreated",
  quote_published: "design.enum.event.quotePublished",
  quote_paid: "design.enum.event.quotePaid",
  quote_cancelled: "design.enum.event.quoteCancelled",
  sample_decision: "design.enum.event.sampleDecision",
  prototype_shipped: "design.enum.event.prototypeShipped",
};

export const translateDesignValue = (t, keyMap, value) => (
  keyMap[value] ? t(keyMap[value]) : t("design.enum.unknown")
);

export const readApiError = async (response, fallback) => {
  await response.json().catch(() => ({}));
  return fallback;
};

export const createLocalizedError = (message) => {
  const error = new Error(message);
  error.isLocalized = true;
  return error;
};

export const localizedErrorMessage = (error, fallback) => (
  error?.isLocalized ? error.message : fallback
);

export const formatProjectDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
};

export const formatUsd = (cents) => (
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
    .format(Number(cents || 0) / 100)
);

export const privateFileUrl = (file) => {
  const path = file?.url || "";
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${CUSTOM_DESIGN_API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
};

export const humanizeEvent = (eventType) => (
  String(eventType || "")
    .replace(/_/g, " ")
    .replace(/^\w/, (character) => character.toUpperCase())
);
